export const baseURL = process.env.PUBLIC_URL || 'http://localhost:3000';
export const baseApiURL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
export const baseStrapiURL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';

export const endTitlePage = " | Accompagnement à la parentalité | Co-éducation émotionnelle | Montpellier";